import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core'
import { MatSort, MatSortHeader } from '@angular/material/sort'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
} from '@angular/material/table'
import { DataContextBuilder, ElderTableComponent, IDataContext, Sort } from '@elderbyte/ngx-starter'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { PackageKind, PackageType } from '../package-type'
import { PackageTypeService } from '../package-type.service'

@Component({
  selector: 'app-package-type-browser',
  templateUrl: './package-type-browser.component.html',
  styleUrls: ['./package-type-browser.component.scss'],
  imports: [
    ElderTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    ElderTranslatePipe,
  ],
})
export class PackageTypeBrowserComponent implements OnInit {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public readonly data: IDataContext<PackageType>

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const packageKindService = inject(PackageTypeService)
    this.data = DataContextBuilder.start<PackageType>().build(packageKindService)
  }

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnInit(): void {
    this.data.start([new Sort('id', 'asc')], this.data.filter.filtersSnapshot)
  }

  /***************************************************************************
   *                                                                         *
   * Public Methods                                                          *
   *                                                                         *
   **************************************************************************/

  public getPackageKindEnumKey(value: PackageKind): string {
    return PackageKind[value as keyof typeof PackageKind]
  }
}
